import errors from './errors.js'
import common from './common.js'
import nav from './nav.js'

export default {
  errors,
  common,
  nav,
}
